import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  TRADE_DATA_DOWNLOAD_LINK,
  TRADE_DATA_MANUAL_LINK_EN,
  TRADE_DATA_MANUAL_LINK_VI,
} from '../../../configs/ContactConfig';
import { listLanguage } from '../../../configs/LanguageConfig';
import textLinkIcon9 from './../../../assets/images/svg/i-9.svg';
import textLinkIcon10 from './../../../assets/images/svg/i-10.svg';
import textLinkIcon11 from './../../../assets/images/svg/i-11.svg';
import textLinkIcon12 from './../../../assets/images/svg/i-12.svg';
import textLinkIcon13 from './../../../assets/images/svg/i-13.svg';
import textLinkIcon14 from './../../../assets/images/svg/i-14.svg';
import textLinkIcon15 from './../../../assets/images/lap-1.png';
import ScrollComponent from '../../common/ScrollComponent';
import PreRender from './../../common/PreRender';
import './trade-data.scss';

class TradeData extends React.Component {
  getManualLink = () => {
    const { i18n } = this.props;
    return i18n.locale === listLanguage.en
      ? TRADE_DATA_MANUAL_LINK_EN
      : TRADE_DATA_MANUAL_LINK_VI;
  };

  render() {
    return (
      <PreRender {...this.props}>
        <ScrollComponent>
          <div className="tradedata-wrapper pl-20 pr-20 h-100 d-flex flex-column">
            <div className="trade-des-ti text-center">
              <h1>{I18n.t('tradeData.title.tradeData')}</h1>
              <p>{I18n.t('tradeData.title.titleHeader')}</p>
            </div>
            <div className="image-and-button d-flex flex-column align-items-center">
              <div>
                <img style={{ width: '250px' }} src={textLinkIcon15} />
              </div>
              <div className="list-btn-ads d-flex flex-column align-center">
                <div>
                  <a
                    href={TRADE_DATA_DOWNLOAD_LINK}
                    target="_blank"
                    className="btn-tradedata btn1"
                  >
                    {I18n.t('tradeData.button.download')}
                    <i className="icon-down-arrow ml-2" />
                  </a>
                  <a
                    href={this.getManualLink()}
                    target="_blank"
                    className="btn-tradedata btn2"
                  >
                    {I18n.t('tradeData.button.userManual')}
                  </a>
                </div>
              </div>
            </div>

            <div className="list-icon-tradedate">
              <div className="item-list-td">
                <img src={textLinkIcon9} />
                <p> {I18n.t('tradeData.button.historicalData')}</p>
              </div>
              <div className="item-list-td">
                <img src={textLinkIcon10} />
                <p> {I18n.t('tradeData.button.realTimeData')}</p>
              </div>
              <div className="item-list-td">
                <img src={textLinkIcon11} />
                <p>{I18n.t('tradeData.button.dataEveryMinute')}</p>
              </div>
            </div>

            <div className="list-icon-tradedate">
              <div className="item-list-td">
                <img src={textLinkIcon12} />
                <p>{I18n.t('tradeData.button.pluginConnect')}</p>
              </div>
              <div className="item-list-td">
                <img src={textLinkIcon13} />
                <p>{I18n.t('tradeData.button.comprehensiveData')}</p>
              </div>
              <div className="item-list-td">
                <img src={textLinkIcon14} />
                <p>{I18n.t('tradeData.button.easyToUse')}</p>
              </div>
            </div>
          </div>
        </ScrollComponent>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(TradeData);
